import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateCommentsForm extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['comments'];
  }

  static get styles() {
    return [...super.styles, css`
      bn-form-field {
        --bn-form-field-min-height: 20vh;
        width: 80%;
        margin: 0 1em;
        --textarea-resize: vertical;
      }
    `];
  }

  render() {
    return html`
      <div class="flex col physical-issue-form">
        <h2>Comments</h2>
        <p>Please describe the issue and add any additional comments which may help with diagnosing this problem</p>
        <bn-form-field
          type="textarea"
          @input="${this._onInput}"
          .value="${this.data.comments}"
        ></bn-form-field>
        ${this.renderSubmit()}
      </div>
    `;
  }

  _onInput(e) {
    this.data.comments = e.target.input.value;
    this.stateHasData = this.data.comments.trim().length > 0;
  }
}

window.customElements.define('bin-issue-state-comments-form', BinIssueStateCommentsForm);
